import React from 'react';

export const FailedIconTooltipText: React.ReactNode = (
  <>Failed due to crash or abort during execution.</>
);
